import { TabRouteType } from '@dfl/react-security';

export const GENERAL_CONCILIATION_TABS: TabRouteType[] = [
  {
    label: 'conciliation:tabs.general',
    translate: true,
    to: '/general',
    path: '/conciliations/main/general',
  },
  {
    label: 'conciliation:tabs.product',
    translate: true,
    to: '/products',
    path: '/conciliations/main/products',
  },
  {
    label: 'conciliation:tabs.logistic',
    translate: true,
    to: '/logistics',
    path: '/conciliations/main/logistics',
  },
  {
    label: 'conciliation:tabs.warehouses',
    translate: true,
    to: '/warehouses',
    path: '/conciliations/main/warehouses',
  },
  {
    label: 'conciliation:tabs.centers',
    translate: true,
    to: '/distribution-centers',
    path: '/conciliations/main/distribution-centers',
  },
  {
    label: 'conciliation:tabs.carrier',
    translate: true,
    to: '/carriers',
    path: '/conciliations/main/carriers',
  },
];

export const CONCILIATION_TABS: TabRouteType[] = [
  {
    label: 'conciliation:tabs.product',
    translate: true,
    to: '/products',
    path: '/conciliations/:id/products',
  },
  {
    label: 'conciliation:tabs.logistic',
    translate: true,
    to: '/logistics',
    path: '/conciliations/:id/logistics',
  },
  {
    label: 'conciliation:tabs.warehouses',
    translate: true,
    to: '/warehouses',
    path: '/conciliations/:id/warehouses',
  },
  {
    label: 'conciliation:tabs.centers',
    translate: true,
    to: '/distribution-centers',
    path: '/conciliations/:id/distribution-centers',
  },
  {
    label: 'conciliation:tabs.carrier',
    translate: true,
    to: '/carriers',
    path: '/conciliations/:id/carriers',
  },
];
